import HttpClienteSeguroCore from '../../Servicios/HttpClienteSeguroCore';

// Se encacarga de listar las carreras para el buscador
//dsc: descripción para buscar el codigo o nombre
//sts: estado: 1 activo, 0 inactivo
//companyId: identificador de la compañía
export const ListadoBuscadorCarreras = ({ dsc, sts, cat, companyId, PeticionUsuario }) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Buscadores/Carreras/', {
            Dsc: dsc, Cat: cat, Sts: sts, CompanyId: companyId, AccionPeticionValidar: PeticionUsuario
        }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};


// Se encacarga de listar los cursos para el buscador
//dsc: descripción para buscar el codigo o nombre
//sts: estado: 1 activo, 0 inactivo
//companyId: identificador de la compañía
export const ListadoBuscadorCursos = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Buscadores/Cursos/', filtro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de listar los programas academicos para el buscador
//careerId: id de la carrera vinculada, se puede enviar vacio para traer todos los programas
//gradeId: id del grado vinculado, se puede enviar vacio para traer todos los programas
//dsc: descripción para buscar el codigo o nombre
//sts: estado: 1 activo, 0 inactivo
//companyId: identificador de la compañía
//campusId: identificador de la sede
//userId: identificador del usuario
//PortalNewEntry: Indica si estan ingresando desde el portal nuevo ingreso
export const ListadoBuscadorProgramasAca = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Buscadores/ProgramasAca/', filtro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de listar de registros activos para buscador de clientes
//Id: Identificacion del cliente
//Nombre: Nombre del cliente
//Profile: Perfil del cliente
//companyId: identificador de la compañía
export const ListadoBuscadorClientes = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Buscadores/Clientes/', filtro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de obtener un cliente por su identificacion
//Ide: Identificacion del cliente
//Profile: Perfil del cliente
//companyId: identificador de la compañía
export const BuscarClientesPorIde = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Buscadores/ClientePorIde/', filtro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Obtiene un listado de cursos de un programa especifico 
//ProgramId: Identificador del programa
//Dsc: Descripción filtro
export const ListadoCursosPrograma = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Buscadores/CursosProgramas/', filtro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se usa para obtener un cliente por su id
export const obtenerClientePorId = (IdCliente) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.get("/Buscadores/ClienteEspecifico/" + IdCliente).then(response => {
            resolve(response);

        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

/**
 * 
 * @param {{
 *  careerId:string, 
 * gradeId:string, 
 * dsc:string, sts:string, 
 * companyId:string, 
 * campusId:string, userId:string, peticionUsuario:{ action:string, optionId:string, userId:string, companyId:string,}}} filtro 
 * @returns {Promise<{data:Array<{id:string, code:string, dsc:string }>, status:number}>}
 */
export const ListadoPortalProgramasAca = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Buscadores/Portal/ProgramasAca', filtro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};
